import { isAuth0Enabled } from 'ext/lib/auth/web';
import initializeAuth0 from './initialize.auth0';
import initializeLegacy from './initialize.legacy';

const setUserSignature = signature => {
  if (window.AppcuesSettings) {
    window.AppcuesSettings.userIdSignature = signature;
  } else {
    window.AppcuesSettings = { userIdSignature: signature };
  }
};

const initialize = async () => {
  const result = isAuth0Enabled()
    ? await initializeAuth0()
    : await initializeLegacy();

  if (result?.user?.signature) {
    setUserSignature(result.user.signature);
  }

  return result;
};

export default initialize;
